
import placeholder from './image.gif'

export default {
  name: 'VsImage',
  props: {
    source: {
      type: String,
      default: null
    },
    src: {
      type: String,
      default: null
    },
    srcset: {
      type: Array,
      default: null
    },
    size: {
      type: Object,
      default: null
    },
    inline: {
      type: [Boolean, Object],
      default: false
    },
    ratio: {
      type: [String, Boolean, Object],
      default: null
    },
    fit: {
      type: [String, Object],
      default: 'cover'
    },
    position: {
      type: [String, Object],
      default: 'center'
    },
    fillParent: {
      type: [Boolean, Object],
      default: false
    },
    lazy: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    },
    tag: {
      type: String,
      default: 'div'
    },
    title: {
      type: String,
      default: null
    },
    alt: {
      type: String,
      default: null
    },
    metadata: {
      type: Object,
      default: null
    },
    draggable: {
      type: [String, Boolean],
      default: null
    }
  },
  vessel: {
    wrapper: {
      $attrs: 'all',
      width: 'full',
      $fillParent: {
        position(value) {
          return value ? 'relative' : null
        },
        height(value) {
          return value ? 'full' : null
        }
      },
      $inline: {
        display(value) {
          return value ? 'inline-block' : 'block'
        }
      }
    },
    container: {
      $fillParent: {
        position(value) {
          return value ? 'absolute' : 'relative'
        },
        width(value) {
          return value ? 'full' : null
        },
        minHeight(value) {
          return value ? 'full' : null
        }
      },
      $ratio: {
        aspectRatio(value) {
          return value
        },
        height(value) {
          return value ? 0 : 'full'
        }
      }
    },
    image: {
      width: 'full',
      height: 'full',
      display: 'block',
      $fitValue: 'objectFit',
      $positionValue: 'objectPosition',
      $showAlt: {
        color(value) {
          return value ? null : 'transparent'
        }
      },
      $ratio: {
        position(value) {
          return value ? 'absolute' : 'relative'
        },
        pin(value) {
          return value ? true : 'none'
        }
      }
    },
    slot: {
      position: 'absolute',
      pin: true,
      width: 'full',
      height: 'full'
    }
  },
  watch: {
    href: 'setSource'
  },
  data() {
    return {
      srcValue: (this.placeholder || placeholder),
      srcsetValue: undefined,
      sizesValue: undefined,
      loaded: false,
      error: false,
      showAlt: false
    }
  },
  computed: {
    href() {
      return this.src || this.source
    },
    hasContent() {
      const slots = this.$slots.default
      return slots && slots.length
    },
    metaData() {
      return this.metadata || {}
    },
    loading() {
      return this.lazy ? 'lazy' : undefined
    },
    fitValue() {
      return this.metaData.fit || this.fit
    },
    positionValue() {
      return this.metaData.position || this.position
    },
    sizeValue() {
      const { width, height } = this.metaData
      return { width, height, ...this.size }
    },
    altText() {
      return this.alt || 'Image'
    }
  },
  methods: {
    setSource(value) {
      if (value && value.length) {
        this.srcValue    = value
        this.srcsetValue = this.srcset ? this.srcset.join(', ') : undefined
      }
    },
    setSizes() {
      if (this.srcset) {
        const screen = document.body.offsetWidth || 1024
        const imageW = this.$refs.image && this.$refs.image.offsetWidth

        this.sizesValue = `${Math.ceil((imageW || screen) / screen * 100)}vw`
      }
    },
    loadImage(entry, observer) {
      if (this.lazy) {
        this.setSource(this.href)
      }

      observer.disconnect()
    },
    onLoad(event) {
      this.loaded = true
      this.showAlt = true

      this.$emit('load', event)
    },
    onError(event) {
      this.loaded = false
      this.error = true
      this.showAlt = true

      this.$emit('error', event)
    }
  },
  created() {
    if (!this.lazy) {
      this.setSource(this.href)
    }
  },
  mounted() {
    this.setSizes()
  }
}
